






















import Vue from 'vue';
export default Vue.extend({
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    maxLength: {
      type: Number,
      default: 500,
    },
    rows: {
      type: Number,
      default: 5,
    },
    useDynamicHeight: {
      type: Boolean,
      default: true,
    },
    showTextLength: {
      type: Boolean,
      default: true,
    },
    minHeight: {
      type: String,
      default: '66px',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  computed: {
    inputName() {
      return this.name || this.label || 'input-id';
    },
    inputId() {
      return this.inputName.toLowerCase().replaceAll(' ', '-');
    },
    valueLength() {
      return this.value?.length || 0;
    },
  },
});
